import { useCallback } from "react";
import useCommandFlowStore from "../../store/commandFlowStore";

export const useFocusHandling = (terminalRef) => {
  const { setIsFocused } = useCommandFlowStore();

  const handleInputBlur = useCallback(
    (e) => {
      if (
        terminalRef.current &&
        e.relatedTarget &&
        terminalRef.current.contains(e.relatedTarget)
      ) {
        return;
      }
      setIsFocused(false);
    },
    [setIsFocused, terminalRef]
  );

  const handleContainerFocus = useCallback(() => {
    setIsFocused(true);
  }, [setIsFocused]);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, [setIsFocused]);

  return {
    handleInputBlur,
    handleContainerFocus,
    handleInputFocus,
  };
};
